import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import CountryFlagComponent from '@prisjakt/ui-country-flag';

export const LocationAndCurrencyInfo = styled.div`
  display: flex;
`;

export const Text = styled.p(
  props => css`
    display: flex;
    align-items: center;
    font-size: ${layout.fontSizes.small.desktop.rem};
    color: ${props.theme.text.tertiary};
    margin: 0;
  `
);

export const CountryFlag = styled(CountryFlagComponent)`
  display: block;
  margin-right: ${layout.spacing.xxSmall};

  img {
    height: auto;
  }
`;
